import { useState, useEffect } from "react";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField, Switch, FormControlLabel } from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import { obtenerCatalogoProveedorAereoAction, obtenerVuelosProveedorAllAction, crearVueloProveedorAction, openCircuitoVueloAction } from "../../../ducks/proveedorAereolineaDuck"
import AutoInputIATA from "../AutoInputIATA";
import PickerModHora from "../../../global/PickersModHora";
import { esFechaValida } from "../../../utils/FormatFecha";


const useCatalogoPrveedoresAereos = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorAereoAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const validationSchema = yup.object({
    claveVuelo: yup
        .string("Ingrese una clave vuelo")
        .required("Es requerido"),
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    disponibilidad: yup
        .number("Ingresa un numero")
        .positive("Numero positivo")
        .required("Es requerido"),
    claveVueloRedondo: yup
        .string("Ingrese una clave vuelo")
        .required("Es requerido"),
})

const initialValues = {
    monto: 0,
    claveVuelo: "",
    disponibilidad: 0,
    claveVueloRedondo: "No aplica",
}

const FProveedoresVuelos = () => {
    const [open, setOpen] = useState(false)
    const [isRedondo, setIsRedondo] = useState(false)
    const [idProveedor, setIdProveedor] = useState(0)
    const [fechaInicio, setFechaIncio] = useState(new Date())
    const [fechaRegreso, setFechaRegreso] = useState(new Date())
    useCatalogoPrveedoresAereos()
    const { catalogoProvAereo } = useSelector(store => store.vueloProveedor)
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FormularioReservaStyle()
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [destino, setDestino] = useState({ IdCodigo: 0 })
    const [orgien, setOrigen] = useState({ IdCodigo: 0 })
    const [destinoRegreso, setDestinoRegreso] = useState({ IdCodigo: 0 })
    const [orgienRegreso, setOrigenRegreso] = useState({ IdCodigo: 0 })
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const onClick = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        setTipoMoneda(0)
        setIsRedondo(false)
        setIdProveedor(0)
        formik.resetForm(initialValues);
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const handleClickSelecFechaInicio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaIncio(date)
    }
    const handleClickSelecFechaRegreso = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaRegreso(date)
    }
    const onSave = (values) => {
        if (tipoMoneda === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        if (idProveedor === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una proveedor valido",
            })
            return null
        }
        let vueloReondo = {
            ClaveVuelo: values?.claveVueloRedondo,
            FechaSalida: fechaRegreso,
            IdOrigen: orgienRegreso?.IdCodigo,
            IdDestino: destinoRegreso?.IdCodigo,
        }
        dispatch(onLoadAnction({ message: '' }))
        dispatch(crearVueloProveedorAction({
            ClaveVuelo: values?.claveVuelo,
            Disponibilidad: values?.disponibilidad,
            EsRedondo: isRedondo,
            FechaSalida: fechaInicio,
            IdDestino: destino?.IdCodigo,
            IdOrigen: orgien?.IdCodigo,
            IdMoneda: tipoMoneda,
            IdProveedor: idProveedor,
            PrecioNeto: values?.monto,
            VueloRedondo: vueloReondo,
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(openCircuitoVueloAction({ vuelo: {IdVuelo: Response}}))
            dispatch(obtenerVuelosProveedorAllAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    const handleChangeIsRedondo = (event) => {
        let redondo = event.target.checked
        setIsRedondo(redondo)
        if (redondo) {
            formik.setFieldValue("claveVueloRedondo", "")
        } else {
            formik.setFieldValue("claveVueloRedondo", "No aplica")
        }
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />}>
                Nuevo vuelos
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo vuelos`}
                />

                <form onSubmit={formik.handleSubmit}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Grid container className={classes.containerSpacing}>
                                <Grid item xs={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lTipoProveedorAereo">Proveedor aereo</InputLabel>
                                        <Select
                                            labelId="lTipoProveedorAereo"
                                            id="STipoProveedorAereo"
                                            name="proveedorAereo"
                                            value={idProveedor}
                                            onChange={handleSelecProveedor}
                                            label="Proveedor aereo"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una opción"}
                                            </MenuItem>
                                            {catalogoProvAereo.map((item, index) => (
                                                <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                                    {item.RazonSocial}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoInputIATA
                                        label="Origen"
                                        name="Origen"
                                        setTarget={setOrigen}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoInputIATA
                                        label="Destino"
                                        name="destino"
                                        setTarget={setDestino}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                        <Select
                                            labelId="lTipoMoneda"
                                            id="STipoMoneda"
                                            name="tipoMoneda"
                                            value={tipoMoneda}
                                            onChange={handleSelecTipoMoneda}
                                            label="Moneda"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una opción"}
                                            </MenuItem>
                                            {catalogoMoneda.map((moneda, index) => (
                                                <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                                    {`${moneda.Clave} - ${moneda.Descripcion}`}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="input-Monto"
                                        label="Monto"
                                        type="text"
                                        variant="outlined"
                                        name="monto"
                                        value={formik.values.monto}
                                        onChange={formik.handleChange}
                                        error={formik.touched.monto && Boolean(formik.errors.monto)}
                                        helperText={formik.touched.monto && formik.errors.monto}
                                        className={classes.textField}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="input-claveVuelo"
                                        label="Clave vuelo"
                                        type="text"
                                        variant="outlined"
                                        name="claveVuelo"
                                        value={formik.values.claveVuelo}
                                        onChange={formik.handleChange}
                                        error={formik.touched.claveVuelo && Boolean(formik.errors.claveVuelo)}
                                        helperText={formik.touched.claveVuelo && formik.errors.claveVuelo}
                                        className={classes.textField}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="input-disponibilidad-vuelo"
                                        label="Disponibilidad"
                                        type="text"
                                        variant="outlined"
                                        name="disponibilidad"
                                        value={formik.values.disponibilidad}
                                        onChange={formik.handleChange}
                                        error={formik.touched.disponibilidad && Boolean(formik.errors.disponibilidad)}
                                        helperText={formik.touched.disponibilidad && formik.errors.disponibilidad}
                                        className={classes.textField}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PickerModHora
                                        id="fechaSalidaVuelo"
                                        label="Fecha de vuelo"
                                        selectedDate={fechaInicio}
                                        setSelectedDate={handleClickSelecFechaInicio}
                                        disablePast={true}
                                        disableFuture={false}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container className={classes.containerSpacing}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isRedondo}
                                                onChange={handleChangeIsRedondo}
                                                name="hcekIsRedondo"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        }
                                        label="Es vuelo redondo"
                                        labelPlacement="start"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="input-claveVueloRegreso"
                                        label="Clave vuelo redondo"
                                        type="text"
                                        variant="outlined"
                                        name="claveVueloRedondo"
                                        value={formik.values.claveVueloRedondo}
                                        onChange={formik.handleChange}
                                        error={formik.touched.claveVueloRedondo && Boolean(formik.errors.claveVueloRedondo)}
                                        helperText={formik.touched.claveVueloRedondo && formik.errors.claveVueloRedondo}
                                        className={classes.textField}
                                        disabled={!isRedondo}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoInputIATA
                                        label="Origen regreso"
                                        name="OrigenRegreso"
                                        setTarget={setOrigenRegreso}
                                        disabled={!isRedondo}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <AutoInputIATA
                                        label="Destino Regreso"
                                        name="destinoRegreso"
                                        setTarget={setDestinoRegreso}
                                        disabled={!isRedondo}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PickerModHora
                                        id="fechaSalidaVueloRedondo"
                                        label="Fecha de vuelo"
                                        selectedDate={fechaRegreso}
                                        setSelectedDate={handleClickSelecFechaRegreso}
                                        disablePast={true}
                                        disableFuture={false}
                                        disabled={!isRedondo}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}
export default FProveedoresVuelos